// Shell v3 chrome contract between AppShell and the layout primitives.
//
// The locked shell grid is app rail | optional subrail | fluid stage, but subrails are
// route content: pages own their sections, the shell owns the column. ShellSubrail bridges
// the two by portaling into a host cell the shell renders between the rail and the stage,
// and by registering so the shell only pays the subrail column while one is mounted.

import { createContext, useContext } from "react";

export interface ShellChromeContextValue {
  /** The grid cell between the app rail and the stage. Null for one commit while it mounts. */
  subrailHost: HTMLElement | null;
  /**
   * Marks a subrail as mounted so the shell switches `.appshell__body` to the three-column
   * template. Returns the cleanup that releases the column again. Counted, not boolean, so
   * a route swap that overlaps two subrails for a frame cannot drop the column mid-swap.
   */
  registerSubrail: () => () => void;
}

export const ShellChromeContext = createContext<ShellChromeContextValue | null>(null);

/** Null outside AppShell (unit tests, embeds); ShellSubrail then renders in place. */
export function useShellChrome(): ShellChromeContextValue | null {
  return useContext(ShellChromeContext);
}
